var _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnSocialPinterest = function SvgBtnSocialPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "btn-social-pinterest_svg__a",
    d: "M0 0h50v50H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "btn-social-pinterest_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btn-social-pinterest_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#btn-social-pinterest_svg__b)",
      fill: "currentColor"
    },
    d: "M25 0C11.193 0 0 11.193 0 25c0 10.178 6.094 18.92 14.82 22.82-.019-1.551.045-4.326.418-5.918.476-2.008 3.186-13.494 3.186-13.494s-.791-1.58-.791-3.918c0-3.67 2.129-6.41 4.777-6.41 2.254 0 3.34 1.693 3.34 3.717 0 2.266-1.443 5.652-2.186 8.789-.623 2.629 1.314 4.77 3.908 4.77 4.691 0 7.851-6.025 7.851-13.166 0-5.428-3.656-9.49-10.303-9.49-7.514 0-12.193 5.602-12.193 11.857 0 2.16.637 3.68 1.633 4.858.457.543.52.764.356 1.383-.117.455-.391 1.551-.504 1.988-.166.627-.674.852-1.238.619C9.611 31.992 8 28.201 8 23.943c0-7.035 5.934-15.471 17.699-15.471 9.457 0 15.68 6.844 15.68 14.188 0 9.711-5.402 16.971-13.363 16.971-2.676 0-5.189-1.443-6.051-3.086 0 0-1.438 5.705-1.742 6.809-.454 1.646-1.84 4.146-2.663 5.521C19.91 49.605 22.41 50 25 50c13.807 0 25-11.193 25-25S38.807 0 25 0z"
  }));
};
export default SvgBtnSocialPinterest;